export const isMobileWidth = () => (window.innerWidth <= 767 ? false : true);

export const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};
